<template>
  <v-dialog v-model="dialog" scrollable persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="primary" rounded dark class="mb-2" v-bind="attrs" v-on="on">
        <v-icon class="mr-1">mdi-plus</v-icon>
        Agregar Dosificacion
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="info white--text">
        <span class="text-center headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="vform" v-model="formValid" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-select
                  outlined
                  color="primary"
                  v-model="form.sucursal"
                  dense
                  :rules="fieldRules"
                  label="Sucursal"
                  :items="sucursales"
                  return-object
                  item-text="ciudad"
                  autofocus
                  
                  hint="123468"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6" xl="12">
                <v-text-field outlined dense :rules="fieldRules" v-model="form.num_factura" label="Num de Factura"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" xl="12">
                <v-text-field  outlined dense :rules="fieldRules" v-model="form.autorizacion" label="Autorizacion"></v-text-field>
              </v-col>

              <v-col cols="12" md="12">
                <v-textarea rows="3" outlined dense v-model="form.codigo_dosificacion" label="Codigo de Dosificacion"></v-textarea>
              </v-col>
              <v-col cols="12" md="12" class="my-0">
                <v-text-field outlined dense hide-details="" v-model="form.linea1" label="linea 1"></v-text-field>
              </v-col>
              <v-col cols="12" md="12" class="my-0">
                <v-text-field outlined dense hide-details="" v-model="form.linea2" label="linea 2"></v-text-field>
              </v-col>
              <v-col cols="12" md="6" xl="12">
                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      outlined
                      dense
                      v-model="form.fecha_limite"
                      label="Fecha Limite de emision"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="form.fecha_limite" @input="menu = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" xl="12">
                <v-textarea rows="2" outlined dense v-model="form.actividad" label="actividad"></v-textarea>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded outlined @click="saveForm"> <v-icon class="mx-1">mdi-content-save</v-icon> Guardar</v-btn>
        <v-btn rounded outlined @click="closeDialog"> <v-icon>mdi-close</v-icon> Cancelar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    editedIndex: { type: Number, default: -1 },
    sucursales: {
      type: Array,
      default: () => [
        { id: 1, nit_id: 2, direccion: 'lejos', ciudad: 'tarija', numero_sucursal: 3, sede_id: 1 },
        { id: 2, nit_id: 1, direccion: 'lejos', ciudad: 'tarija Sucursal', numero_sucursal: 2, sede_id: 2 },
        { id: 3, nit_id: 1, direccion: 'lejos', ciudad: 'Sucre', numero_sucursal: 1, sede_id: 3 },
      ],
    },
  },
  data() {
    return {
      fieldRules: [(v) => !!v || 'Campo Obligatorio'],

      dialog: false,
      formValid: true,
      menu: false,

      form: {
        id: null,
        sucursal_id: null,
        sucursal: null,
        num_factura: null,
        linea1: null,
        linea2: null,
        autorizacion: null,
        codigo_dosificacion: null,
        fecha_limite: new Date().toISOString().substr(0, 10),
        nit: null,
        actividad: null,
      },
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Registro Nuevo' : 'Editar Registro';
    },
  },
  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
  },
  methods: {
    showDialog(item) {
      this.form = Object.assign({}, item);
      this.dialog = true;
    },
    async saveForm() {
      if (this.$refs.vform.validate()) {
        if (await this.$root.$confirm.open('Guardar Datos', 'Estas seguro?')) {
          this.form.sucursal_id = this.form.sucural.id;
          if (this.editedIndex > -1) {
            window.console.log('send post');
          } else {
            window.console.log('send put');
          }
        }
      }
    },
    success() {
      this.$root.$notify.show(`Guardado exitosamente`, { color: 'success' });
      this.closeDialog();
    },

    closeDialog() {
      this.dialog = false;
      this.formValid = true;
      this.form = {
        id: null,
        sucursal_id: null,
        sucursal: null,
        num_factura: null,
        autorizacion: null,
        codigo_dosificacion: null,
        fecha_limite: null,
        nit: null,
        actividad: null,
      };
      this.$nextTick(() => {
        this.$emit('update:editedIndex', -1);
      });
    },
  },
};
</script>
